module.exports = __webpack_public_path__ + "static/img/loginLogo.39f4cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loginLogo.png
// module id = 24WN
// module chunks = 0 1 64